module.exports = __webpack_public_path__ + "img/Thunder.jpg";